import { FC } from 'react';
import { Link } from 'react-router-dom';

import useMainProgressContext from '../../../progress/MainProgress/context/MainProgressContext';

interface DataGridLinkTemplateProps {
  to: string;
  value: string;
  id: string;
}

const DataGridLinkTemplate: FC<DataGridLinkTemplateProps> = (props) => {
  const { show } = useMainProgressContext();

  return (
    <Link className="DataGrid-LinkCell" to={props.to.replace(':id', props.id)} onClick={() => show()}>
      {props.value}
    </Link>
  );
};

export default DataGridLinkTemplate;
